import React from 'react'
import { Link } from 'react-router-dom'
import Source from './SubComponents/Source'
import Target from './SubComponents/Target'
import { paths } from '../../../../../../../app/routes'

const ConnectorListing = ({ integration }) => (
    <div className="col-lg-6 mb-3" id={integration.id}>
        <div className="card-columns card-columns-2 integration-type-listing">
            <div className="conhoverselect">
                <Link
                    to={paths.newConnector({ integration: integration.id, from: 'ege' })}
                    className="btn btn-primary btn-rounded waves-effect waves-light new-connector"
                >
                    Select
                </Link>
            </div>
            <Source image={integration.image} title={integration.source.shortName} />
            <Target image={integration.image} title={integration.target.shortName} />
        </div>
    </div>
)

export default ConnectorListing
